<template>
  <b-modal ref="gun-card-modal" @ok="gunCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.guns.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.guns.tableColumns.trk"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="gun.trk"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.guns.tableColumns.trkNumber"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="1000"
          v-model="trkNumber"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.guns.tableColumns.pumpSerialMedoc"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="pumpSerialMedoc"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.guns.tableColumns.totalCounters"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="gun.totalCounters"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="gun.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateGunPage",
  props: {
    gun: Object,
  },
  components: {},
  data() {
    return {
      trkNumber: null,
      pumpSerialMedoc: null,
      created: null,
      updated: null
    };
  },
  methods: {
    async open() {
      this.trkNumber = this.gun.trkNumber;
      this.pumpSerialMedoc = this.gun.pumpSerialMedoc;
      this.created = utilsService.formatDateTime(new Date(this.gun.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.gun.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["gun-card-modal"].show();
    },
    async gunCardModalOk() {
      this.gun.pumpSerialMedoc = this.pumpSerialMedoc;
      this.gun.trkNumber = this.trkNumber;

      const updateGunResponse = await azkService.updateGun(this.gun);

      if (
        updateGunResponse.isSuccess &&
        updateGunResponse.data &&
        updateGunResponse.data.countInsertedRows == 1
      ) {
        this.$emit("gunUpdatedSuccessEvent");
      } else {
        this.$emit("gunUpdatedFailEvent");
      }
    },
  },
};
</script>
